import { render } from "./middleNumber.vue?vue&type=template&id=72e2bac2&scoped=true"
import script from "./middleNumber.vue?vue&type=script&lang=js"
export * from "./middleNumber.vue?vue&type=script&lang=js"

import "./middleNumber.vue?vue&type=style&index=0&id=72e2bac2&scoped=true&lang=css"
script.render = render
script.__scopeId = "data-v-72e2bac2"

export default script